export default __webpack_public_path__ + "static/B0145-351a624bb94254b43360911e8d6b925f.png";